import styled from 'styled-components';

export const ActionText = styled.p`
  color: #1890ff;
  cursor: pointer;
  margin: 0;
`;
